// @flow
import { Box } from '@mui/material';
import { useI18n } from '@shared/helper';

function HelperText({ message }: { message: string }): React$Node {
	const { translate } = useI18n();
	if (!message) return null;

	if (typeof message === 'string') return message;

	const generateFinalTranslation = ({ value, action, params = {} }) => {
		const translatedParams = Object.keys(params).reduce((init, objectKey) => {
			const result = { ...init };
			const objectResolved = params[objectKey];
			const resultValue = objectResolved?.action === 't' ? translate(objectResolved.value) : objectResolved.value;
			result[objectKey] = resultValue;

			return result;
		}, {});

		console.log({ translatedParams })
		return translate(value, { ...translatedParams });
	}

	return (
		<Box component={'span'}>
			{ generateFinalTranslation(message) }
		</Box>
	);
}

export default HelperText;
